import formatter from "@/common/function/formatter";
import roundToTwoSignificantDecimals from "@/common/function/roundToTwoSignificantDecimals";
import { useAuth } from "@/contexts/Auth";
import { useGlobalData } from "@/contexts/GlobalData";
import { useRealtimeData } from "@/contexts/RealtimeData";
import getMissionsService from "@/services/getMissionsService";

function useFormatter() {
    const { userInfo } = useGlobalData();
    const { tokensRateState } = useRealtimeData();
    const currency = userInfo?.settings?.currency;
    const isDollar = currency?.toLowerCase()?.includes("usd") || currency?.toLowerCase()?.includes("$");
    const rate = tokensRateState?.[currency]?.USD || 1;
    const formatValue = (value: number, hideUnit?: boolean) => {
        const valueDisplay = formatter(roundToTwoSignificantDecimals(value / rate), false, true, false);
        if (hideUnit) return valueDisplay;
        return (isDollar ? "$" : "") + valueDisplay + (isDollar ? "" : ` ${currency}`);
    };
    return {
        formatValue,
    };
}

export default useFormatter;
